/* ====================================================================
 * Ricerca assistita — pannello suggerimenti nella finestra di ricerca
 * e recupero dei termini quando la ricerca del negozio non trova nulla.
 *
 * I prodotti non hanno tag né tipo, quindi la ricerca predittiva di
 * Shopify lavora solo sul titolo: una mappa di sinonimi tradotta prima
 * della chiamata recupera i termini che i clienti usano davvero.
 * ==================================================================== */
(function () {
  'use strict';

  var DATA = {};
  try {
    var node = document.getElementById('fo-shop-data');
    if (node) DATA = JSON.parse(node.textContent);
  } catch (e) {
    DATA = {};
  }

  var SEARCH_URL = DATA.searchUrl || '/search';
  var SUGGEST_URL = (DATA.predictiveUrl || '/search/suggest') + '.json';

  var SYNONYMS = {
    vestito: ['abito', 'dress'],
    vestiti: ['abiti', 'dress'],
    abito: ['dress', 'abiti'],
    abiti: ['dress', 'abito'],
    dress: ['abito'],
    completo: ['coordinato', 'co-ords', 'tailleur'],
    completi: ['coordinato', 'co-ords', 'tailleur'],
    coordinato: ['co-ords', 'completo'],
    cappotto: ['outwear', 'outerwear', 'cappotti'],
    cappotti: ['outwear', 'outerwear'],
    capospalla: ['outwear', 'cappotto'],
    giacca: ['tailleur', 'blazer'],
    giacche: ['tailleur', 'blazer'],
    blazer: ['tailleur', 'giacca'],
    tailleur: ['giacca', 'completo'],
    gonna: ['skirt'],
    gonne: ['skirt'],
    pantalone: ['pantaloni', 'pants'],
    pantaloni: ['pants', 'pantalone'],
    camicia: ['shirt', 'blusa'],
    camicie: ['shirt', 'blusa'],
    blusa: ['top', 'camicia'],
    maglia: ['top', 'knit'],
    borsa: ['bag'],
    scarpe: ['shoes'],
    sera: ['cerimonia', 'abito'],
    cerimonia: ['sera', 'abito'],
    sposa: ['cerimonia', 'abito']
  };

  /* Termini che non compaiono nei titoli ma hanno una collezione dedicata. */
  var COLLECTION_HINTS = {
    cappotto: 'outwear',
    cappotti: 'outwear',
    capospalla: 'outwear',
    giacca: 'outwear',
    giacche: 'outwear',
    giubbino: 'outwear',
    trench: 'outwear',
    outerwear: 'outwear',
    vestito: 'dress',
    vestiti: 'dress',
    abito: 'dress',
    abiti: 'dress',
    dress: 'dress',
    completo: 'co-ords',
    completi: 'co-ords',
    coordinato: 'co-ords',
    coordinati: 'co-ords',
    tailleur: 'tailleur',
    blazer: 'tailleur',
    saldi: 'sale',
    sconti: 'sale',
    offerte: 'sale',
    promozioni: 'sale'
  };

  function collectionHint(query) {
    var words = (query || '').toLowerCase().split(/\s+/);
    var handle = null;

    words.some(function (word) {
      handle = COLLECTION_HINTS[word];
      return !!handle;
    });
    if (!handle) return null;

    var match = (DATA.collections || []).filter(function (entry) {
      return entry.url && entry.url.toLowerCase().indexOf('/' + handle) > -1;
    })[0];

    return match || null;
  }

  /* Restituisce le riscritture della query, in ordine di tentativo. */
  function expand(query) {
    var raw = (query || '').trim().toLowerCase();
    if (!raw) return [];

    var words = raw.split(/\s+/);
    var out = [];

    words.forEach(function (word, index) {
      var alternatives = SYNONYMS[word];
      if (!alternatives) return;
      alternatives.forEach(function (alternative) {
        var copy = words.slice();
        copy[index] = alternative;
        out.push(copy.join(' '));
      });
    });

    // Con più parole, provare anche i singoli termini salva le ricerche
    // tipo "vestito rosso" quando il titolo del capo non contiene il colore.
    if (words.length > 1) {
      words.forEach(function (word) {
        out.push(word);
        (SYNONYMS[word] || []).forEach(function (alternative) {
          out.push(alternative);
        });
      });
    }

    return out.filter(function (term, index) {
      return term !== raw && out.indexOf(term) === index;
    });
  }

  function suggest(query, limit) {
    var url =
      SUGGEST_URL +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' +
      (limit || 6) +
      '&resources[options][unavailable_products]=last';

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (payload) {
        var products =
          (payload && payload.resources && payload.resources.results && payload.resources.results.products) || [];
        return products;
      })
      .catch(function () {
        return [];
      });
  }

  /* Cerca il termine originale e, a vuoto, i sinonimi: al primo risultato si ferma. */
  function suggestWithSynonyms(query, limit) {
    return suggest(query, limit).then(function (products) {
      if (products.length) return { term: query, products: products };

      var candidates = expand(query).slice(0, 4);
      if (!candidates.length) return { term: query, products: [] };

      return candidates.reduce(function (chain, candidate) {
        return chain.then(function (found) {
          if (found.products.length) return found;
          return suggest(candidate, limit).then(function (products) {
            return products.length ? { term: candidate, products: products } : found;
          });
        });
      }, Promise.resolve({ term: query, products: [] }));
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function thumbUrl(product) {
    var source = product.featured_image ? product.featured_image.url : product.image;
    if (!source) return '';
    return source.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_200x$1$3');
  }

  function resultsMarkup(products) {
    return (
      '<ul class="fo-sp__results">' +
      products
        .map(function (product) {
          var image = thumbUrl(product);
          return (
            '<li><a class="fo-sp__item" href="' +
            escapeHtml(product.url) +
            '">' +
            (image
              ? '<img class="fo-sp__thumb" src="' + escapeHtml(image) + '" alt="" loading="lazy" width="56" height="74">'
              : '<span class="fo-sp__thumb"></span>') +
            '<span class="fo-sp__name">' +
            escapeHtml(product.title) +
            '</span></a></li>'
          );
        })
        .join('') +
      '</ul>'
    );
  }

  function chipsMarkup(items) {
    return (
      '<ul class="fo-chips">' +
      items
        .map(function (item) {
          return '<li><a class="fo-chip" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></li>';
        })
        .join('') +
      '</ul>'
    );
  }

  function searchLink(term) {
    return SEARCH_URL + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }

  function idleMarkup() {
    var blocks = '';

    if ((DATA.popular || []).length) {
      blocks +=
        '<div class="fo-sp__block"><p class="fo-sp__title">Ricerche frequenti</p>' +
        chipsMarkup(
          DATA.popular.map(function (term) {
            return { title: term, url: searchLink(term) };
          })
        ) +
        '</div>';
    }

    if ((DATA.collections || []).length) {
      blocks +=
        '<div class="fo-sp__block"><p class="fo-sp__title">Le collezioni</p>' + chipsMarkup(DATA.collections) + '</div>';
    }

    return blocks;
  }

  /* ---- Pannello nella finestra di ricerca ---------------------------- */

  function mountPanel() {
    var modal = document.getElementById('search-modal');
    if (!modal || modal.querySelector('.fo-sp')) return;

    var host = modal.querySelector('.growth-area');
    var form = modal.querySelector('.search-form');
    var input = modal.querySelector('input[name="q"]');
    if (!host || !form || !input) return;

    var panel = document.createElement('div');
    panel.className = 'fo-sp fo-shop';
    panel.innerHTML = idleMarkup();
    host.appendChild(panel);

    var timer = null;
    var lastQuery = '';

    function render(query) {
      if (!query) {
        panel.innerHTML = idleMarkup();
        return;
      }

      suggestWithSynonyms(query, 6).then(function (found) {
        if (input.value.trim() !== query) return;

        if (!found.products.length) {
          var hint = collectionHint(query);
          panel.innerHTML =
            '<div class="fo-sp__block"><p class="fo-sp__empty">Nessun capo corrisponde a “' +
            escapeHtml(query) +
            '”. Prova con un termine più semplice o sfoglia le collezioni.</p>' +
            (hint ? chipsMarkup([hint]) : '') +
            '</div>' +
            idleMarkup();
          return;
        }

        var heading =
          found.term.toLowerCase() === query.toLowerCase()
            ? 'Capi trovati'
            : 'Forse cercavi “' + escapeHtml(found.term) + '”';

        panel.innerHTML =
          '<div class="fo-sp__block"><p class="fo-sp__title">' +
          heading +
          '</p>' +
          resultsMarkup(found.products) +
          '<p class="fo-sp__all"><a class="fo-link" href="' +
          escapeHtml(searchLink(found.term)) +
          '">Vedi tutti i risultati</a></p></div>';
      });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (query === lastQuery) return;
      lastQuery = query;
      clearTimeout(timer);
      timer = setTimeout(function () {
        render(query);
      }, 260);
    });

    // Se il termine viene recuperato da un sinonimo, la ricerca completa
    // deve partire da quello, altrimenti la pagina risultati resta vuota.
    form.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query) return;

      var link = panel.querySelector('.fo-sp__all a');
      if (!link) return;

      var target = new URL(link.href, window.location.origin);
      if (target.searchParams.get('q') === query) return;

      event.preventDefault();
      window.location.href = link.href;
    });
  }

  /* ---- Recupero sulla pagina "nessun risultato" ---------------------- */

  function mountNoResults() {
    var host = document.querySelector('[data-fo-noresults]');
    if (!host) return;

    var slot = host.querySelector('[data-fo-didyoumean]');
    var query = host.getAttribute('data-fo-query') || '';
    if (!slot || !query) return;

    var hint = collectionHint(query);
    var candidates = expand(query).slice(0, 5);

    if (!candidates.length) {
      if (hint) {
        slot.innerHTML =
          '<div class="fo-search-aside__block"><h3 class="fo-search-aside__title">Forse cercavi</h3>' +
          chipsMarkup([hint]) +
          '</div>';
      }
      return;
    }

    Promise.all(
      candidates.map(function (candidate) {
        return suggest(candidate, 4).then(function (products) {
          return { term: candidate, products: products };
        });
      })
    ).then(function (found) {
      var usable = found.filter(function (entry) {
        return entry.products.length;
      });

      if (!usable.length) {
        if (hint) {
          slot.innerHTML =
            '<div class="fo-search-aside__block"><h3 class="fo-search-aside__title">Forse cercavi</h3>' +
            chipsMarkup([hint]) +
            '</div>';
        }
        return;
      }

      var chips = usable.map(function (entry) {
        return { title: entry.term, url: searchLink(entry.term) };
      });
      if (hint) chips.unshift(hint);

      slot.innerHTML =
        '<div class="fo-search-aside__block"><h3 class="fo-search-aside__title">Forse cercavi</h3>' +
        chipsMarkup(chips) +
        '</div>' +
        '<div class="fo-search-aside__block"><ul class="fo-cards">' +
        usable[0].products
          .slice(0, 4)
          .map(function (product) {
            var image = thumbUrl(product).replace('_200x', '_640x');
            return (
              '<li><a class="fo-card" href="' +
              escapeHtml(product.url) +
              '"><span class="fo-card__media">' +
              (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '') +
              '</span><span class="fo-card__body"><span class="fo-card__name">' +
              escapeHtml(product.title) +
              '</span></span></a></li>'
            );
          })
          .join('') +
        '</ul></div>';
    });
  }

  function init() {
    mountPanel();
    mountNoResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
